module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-collector-5.b4201059.svg";